import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useTokens } from '../components/TokenContext';

function Games() {
    const [games, setGames] = useState([]);
    const navigate = useNavigate();
    const { tokens, fetchTokens } = useTokens();
    const inputRef = useRef();

    useEffect(() => {
        fetch('https://api.fantasyworldtrpg.cz/casino-api/getgames.php')
            .then(response => response.json())
            .then(data => setGames(data))
            .catch(error => console.error('Chyba při načítání her:', error));
    }, []);

    const change = (arg, s) => {
        if (arg > 0) {
            const userId = localStorage.getItem('fw_user');
            fetch(`https://api.fantasyworldtrpg.cz/casino-api/change.php?t=${arg}&s=${s}&user_id=${userId}`)
                .then(response => response.json())
                .then(data => {
                    fetchTokens()
                    Swal.fire({
                        title: data.title,
                        text: data.message,
                        icon: data.icon,
                        timer: 5000,
                        confirmButtonText: data.btn ?? "Ok",
                        background: "#1c1c1c",
                        color: "#FA4547"
                    });
                });
        }
        else {
            Swal.fire({
                title: `Zadej platnou hodnotu`,
                icon: 'error',
                timer: 5000,
                background: "#1c1c1c",
                color: "#FA4547"
            });
        }
    }

    const handleGameClick = (game) => {
        fetch(`https://api.fantasyworldtrpg.cz/casino-api/checkgame.php?name=${game.name}`)
            .then(response => response.json())
            .then(data => {
                if (data.closed != 1) {
                    if (data.active === '1' || data.active === '2') {
                        navigate(`/game/${game.name}`);
                    }
                    else {
                        Swal.fire({
                            title: `Hra ${game.label} je mimo provoz.`,
                            icon: 'error',
                            timer: 5000,
                            background: "#1c1c1c",
                            color: "#FA4547"
                        });
                    }
                }
                else {
                    Swal.fire({
                        title: `Casino je otevřené pouze o víkendu`,
                        icon: 'error',
                        timer: 5000,
                        background: "#1c1c1c",
                        color: "#FA4547"
                    });
                }
            })
            .catch(error => console.error('Chyba při ověřování hry:', error));
    };

    return (
        <Container>
            <div className="text-center fs-1 my-3">
                Casino San Hillesh
            </div>
            <div className="text-center my-4 change">
                <div className="lead">Směnárna</div>
                <input ref={inputRef} min="1" type="number" name="tokens"/><br/>
                <button onClick={() => change(inputRef.current.value, 'p')} className="btn btn-danger btn-sm m-1">Vložit</button>
                <button onClick={() => change(inputRef.current.value, 'm')} className="btn btn-danger btn-sm m-1">Vybrat</button>
                <p className="lead">Momentálně máš {tokens} Coinů</p>
            </div>
            <Row>
            {games.map((game) => (
                    <Col key={game.name} xs={12} sm={6} md={4} lg={3} className="mb-3">
                        <Card
                            className={`game-card ${game.active === '0' ? 'inactive' : ''}`}
                            onClick={() => handleGameClick(game)}
                        >
                            <Card.Img src={game.img} alt={game.label} />
                            <Card.Body>
                                <Card.Title>{game.label} {(game.active === '2' ? '[DEV Only]' : '')}</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}

export default Games;